/**
 * OpeningPopover — cursor-following popover shown on window hover in InfoMode.
 *
 * Works for both plain windows (entrance: false) and balcony/terrace doors
 * (entrance: true). Currently insolation-only, because window area and
 * cardinal direction are pending in the product data.
 */

import { useI18n } from '../../../../shared/i18n/useI18n.js'

import { buildOpeningItems } from '../../utils/popoverItems.js'

import { BottomSheet } from '../../../../shared/ui/BottomSheet/BottomSheet.jsx'
import { DataGrid } from '../../../../shared/ui/DataGrid/index.js'

import { HoverPopoverCard }  from './HoverPopoverCard.jsx'

/**
 * @param {object}              props
 * @param {object|null}         props.window    — one entry from product.tiers[n].windows[]
 * @param {{x:number,y:number}} props.position  — seed cursor position for initial placement
 * @param {boolean}             props.isMobile  — indicates if the device is mobile
 * @param {boolean}             props.isOpen    — controls Popover visibility
 * @param {function}            [props.onClose] — called by Popover on Escape / scroll
 */
export function OpeningPopover({ window: win, position, isMobile, isOpen, onClose }) {
  const { t } = useI18n()

  const header = win?.entrance ? t('product.opening_window_entrance_cad') : t('product.opening_window')
  const items  = win ? buildOpeningItems(win, t) : []

  if (isMobile) {
    return (
      <BottomSheet isOpen={isOpen} onClose={onClose}>
        <BottomSheet.Header closeLabel={t('product.popover_close')}>
          <span>{header}</span>
        </BottomSheet.Header>
        <BottomSheet.Content>
          <DataGrid items={items} columns={2} size="small" />
        </BottomSheet.Content>
      </BottomSheet>
    )
  }

  return (
    <HoverPopoverCard
      isOpen={isOpen}
      position={position}
      onClose={onClose}
      header={header}
      items={items}
      maxColumns={2}
    />
  )
}
